<template>
  <div>
    <div class="app-top">
      <top-title :dataList="topTitleList" :height="300"></top-title>
    </div>
    <div class="container">
      <div class="row">
        <!-- 网页版 -->
        <div class="col-12 col-md-6 col-lg">
          <div class="down-box">
            <div>
              <img src="@/assets/images/web.png" alt />
            </div>
            <div
              @click="openUrl(`https://${productCode}.jiandanke.cn/web/#/login`)"
              class="my-m-t-10 btn2"
              :style="{background:`linear-gradient(306deg,#B2EABF, #74D689)`}"
            >登录电脑网页版</div>
            <!-- <el-link
              :underline="false"
              type="primary"
              icon="el-icon-discover"
              @click="openUrl(`https://${productCode}.jiandanke.cn/web/#/login`)"
            >登录电脑网页版</el-link>-->
            <div class="my-font-xs my-type-info my-m-t-10">无需下载，打开即用</div>
          </div>
        </div>
        <!-- 客户端 -->
        <div class="col-12 col-md-6 col-lg">
          <div class="down-box">
            <div>
              <img src="@/assets/images/windows.png" alt />
            </div>

            <div @click="openDownloadUrl()" class="my-m-t-10 btn2" :style="{background:`linear-gradient(306deg,#B2EABF, #74D689)`}">下载电脑客户端</div>

            <!-- <el-link :underline="false" type="primary" icon="el-icon-download" @click="openDownloadUrl">下载电脑客户端</el-link> -->
            <div class="my-font-xs my-type-info my-m-t-10">
              <el-link :underline="false" type="info" icon="el-icon-warning-outline" @click="dialogFormVisible=true">下载遇到问题？</el-link>
            </div>
          </div>
        </div>
        <!-- 手机版（小程序） -->
        <div class="col-12 col-md-6 col-lg" v-if="softPrice.softXcxQrCodeUrl">
          <div class="down-box">
            <div>
              <img :src="softPrice.softXcxQrCodeUrl" alt />
            </div>
            <el-link :underline="false" style="line-height: 50px;">手机版(小程序)</el-link>
            <div class="my-font-xs my-type-info my-m-t-10">微信扫一扫 数据同步</div>
          </div>
        </div>
        <!-- 联系客服 -->
        <div class="col-12 col-md-6 col-lg">
          <div class="down-box">
            <div>
              <img :src="require('@/assets/images/service_qrcode_1.jpg')" alt />
            </div>
            <el-link :underline="false" style="line-height: 50px;">联系客服</el-link>
            <div class="my-font-xs my-type-info my-m-t-10">助您快速了解是否合适</div>
          </div>
        </div>
      </div>
      <!-- <div>
          <contact-service></contact-service>
      </div>-->
      <div v-if="dialogFormVisible">
        <el-dialog title="下载遇到问题？" append-to-body :visible.sync="dialogFormVisible" @close="dialogFormVisible = false" width="500">
          <div class="my-text-center">
            <div>
              <img style="width:100%;" :src="require('@/assets/images/download-error.png')" alt />
            </div>
            <contact-service title="联系客服" desc></contact-service>
          </div>
        </el-dialog>
      </div>
    </div>
    <wx-guide ref="wxGuide" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import topTitle from '@/_myComponents/topTitle'
import wxGuide from '@/_myComponents/WxGuide'

export default {
  name: '',
  components: {
    topTitle,
    wxGuide
  },
  data() {
    return {
      topTitleList: [],
      dialogFormVisible: false
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['softPrice']),
    productCode() {
      return this.utils.getProductCode()
    }
  },
  created() {
    //保存邀请码
    this.onloadArgs.saveInvite(this.$route.query)
    this.utils.refreshSoftPrice(this.onloadArgs.getInvite())
    this.topTitleList = [
      {
        image: '',
        title: '下载中心',
        subTitle: '',
        backgroundImage: require('@/assets/images/bg/bg-8.jpg'),
        backgroundColor: `linear-gradient(rgba(${this.utils.hexToRgb(this.softPrice.softThemeColor)},0.5),rgba(${this.utils.hexToRgb(
          this.softPrice.softThemeColor
        )},0.1))`
      }
    ]
  },
  methods: {
    openUrl(url) {
      let newUrl = url
      if (this.onloadArgs.getInvite()) {
        newUrl = newUrl + `/#/?invite=${this.onloadArgs.getInvite()}`
      }
      window.open(newUrl, '_blank ')
    },
    openDownloadUrl() {
      this.$refs.wxGuide.open().then(() => {
        let url = this.softPrice.softSetupUrl
        if (this.onloadArgs.getInvite()) {
          url = url + `&invite=${this.onloadArgs.getInvite()}`
        }
        window.open(url)
      })
    }
  },

  mounted() {}
}
</script>
<style lang="scss" scoped>
// --------------------移动端--------------------
@media screen and (max-width: 576px) {
  .down-box {
    padding: 10px !important;
    margin: 10px !important;
    img {
      margin: 10px 0 !important;
    }
  }
}
// --------------------电脑端--------------------
.app-top {
  margin-top: 58px;
}
.down-box {
  text-align: center;
  padding: 20px;
  min-height: 240px;
  background: #ffffff;
  margin: 30px 0;
  border: 1px solid #ddd;
  border-radius: 15px;
  img {
    width: 128px;
    height: 128px;
    margin: 10px 0;
    // border-radius: 50%;
  }
  a {
    font-size: 14px;
  }
  &:hover {
    background: #f5f5f5;
    border-color: #ccc;
  }
}
</style>